import { ApolloLogo } from '@jouzen/ecom-components/icons/ApolloLogo';
import { CronometerLogo } from '@jouzen/ecom-components/icons/CronometerLogo';
import { MyFitnessPalLogo } from '@jouzen/ecom-components/icons/MyFitnessPalLogo';
import { TalkspaceLogo } from '@jouzen/ecom-components/icons/TalkspaceLogo';
import { ZeroLogo } from '@jouzen/ecom-components/icons/ZeroLogo';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

type TabCategory = (typeof TAB_CATEGORIES)[number];

interface CategorizedIntegration extends LandingPageIntegrationData {
  category: TabCategory;
}

const TAB_CATEGORIES = [
  'sleep',
  'activity_and_performance',
  'womens_health',
  'food_and_nutrition',
  'mental_health',
] as const;

export const tabsByCategory: [TabCategory, MessageKey][] = [
  ['sleep', 'integrations_all_integrations_sleep_tab'],
  [
    'activity_and_performance',
    'integrations_all_integrations_activity_and_performance_tab',
  ],
  ['womens_health', 'integrations_all_integrations_womens_health_tab'],
  [
    'food_and_nutrition',
    'integrations_all_integrations_food_and_nutrition_tab',
  ],
  ['mental_health', 'integrations_all_integrations_mental_health_tab'],
];

export const integrationsByCategory: CategorizedIntegration[] = [
  {
    category: 'food_and_nutrition',
    description: 'integrations_myfitnesspal_description',
    Logo: MyFitnessPalLogo as SVGIconComponent,
    name: 'MyFitnessPal',
  },
  {
    category: 'sleep',
    description: 'integrations_cronometer_description',
    Logo: CronometerLogo as SVGIconComponent,
    name: 'Cronometer',
  },
  {
    category: 'sleep',
    description: 'integrations_zero_description',
    Logo: ZeroLogo as SVGIconComponent,
    name: 'Zero',
  },
  {
    category: 'mental_health',
    description: 'partnerships_apollo',
    Logo: ApolloLogo as SVGIconComponent,
    name: 'Apollo',
  },
  {
    category: 'mental_health',
    description: 'partnerships_integrations_talkspace_copy',
    Logo: TalkspaceLogo as SVGIconComponent,
    logoClassName: 'w-40 xl:w-48',
    name: 'Talkspace',
  },
];
